import { service } from '../axios';
export function saveConsInventoryCheck(data) {
    return service({
        url: '/cons/inventoryCheck/save',
        method: 'post',
        data,
    });
}
export function getConsInventoryCheckDetail(params) {
    return service({
        url: '/cons/inventoryCheck/detail',
        method: 'get',
        params
    });
}
export function checkPreview(data) {
    return service({
        url: '/cons/inventoryCheck/checkPreview',
        method: 'post',
        data
    });
}
export function syncInventoryCheckItems(params) {
    return service({
        url: '/cons/inventoryCheck/syncInventoryCheckItems',
        method: 'post',
        params
    });
}
export function updateInventoryCheckStatus(params) {
    return service({
        url: '/cons/inventoryCheck/updateInventoryCheckStatus',
        method: 'post',
        params
    });
}
export function getInventoryCheckItems(params) {
    return service({
        url: '/cons/inventoryCheck/getInventoryCheckItems',
        method: 'get',
        params
    });
}
export function saveInventoryCheckItems(data) {
    return service({
        url: '/cons/inventoryCheck/saveInventoryCheckItems',
        method: 'post',
        data
    });
}
export function deleteInventoryCheck(checkId) {
    return service({
        url: `/cons/inventoryCheck/delete/${checkId}`,
        method: 'post'
    });
}
